import { ReactNode } from 'react';
import { anyToStr } from 'app/utils/common';

interface Props<T> {
  title?: string;
  items: T[];
  renderItem?: (item: T) => ReactNode;
}

export function List<T extends string | object>({
  title,
  items,
  renderItem = anyToStr,
}: Props<T>): ReactNode {
  return (
    <>
      {title != null && <h4>{title}:</h4>}
      <ul>
        {items.map((item, i) => (
          <li key={i}>{renderItem(item)}</li>
        ))}
      </ul>
    </>
  );
}
